'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dDate$002dTime$002dPrinter$002dParser from "./java.time.format.internal.-Date-Time-Printer-Parser.js";
var $p;
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__($thiz, printerParsers, optional) {
  $thiz.hI = printerParsers;
  $thiz.jW = optional;
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__ };
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__($thiz, printerParsers, optional) {
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__($thiz, printerParsers.CF(new ($j_java$002etime$002eformat$002einternal$002e$002dDate$002dTime$002dPrinter$002dParser.$d_Ljava_time_format_internal_DateTimePrinterParser.r().C)(printerParsers.T())), optional);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser() {
  this.hI = null;
  this.jW = false;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser };
$p = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype = $p;
$p.R0 = (function(optional) {
  return ((optional === this.jW) ? this : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.hI, optional));
});
$p.hr = (function(context, buf) {
  var length = buf.l();
  if (this.jW) {
    context.CB();
  }
  try {
    var i = 0;
    while ((i < this.hI.a.length)) {
      if ((!this.hI.a[i].hr(context, buf))) {
        buf.Qk(length);
        return true;
      }
      i = ((1 + i) | 0);
    }
  } finally {
    if (this.jW) {
      context.TK();
    }
  }
  return true;
});
$p.gG = (function(context, text, position) {
  if (this.jW) {
    context.CB();
    var pos = position;
    var i = 0;
    while ((i < this.hI.a.length)) {
      var pp = this.hI.a[i];
      pos = pp.gG(context, text, pos);
      if ((pos < 0)) {
        context.OO(false);
        return position;
      }
      i = ((1 + i) | 0);
    }
    context.OO(true);
    return pos;
  } else {
    var xs = this.hI;
    var f = ((x$1$3, x$2$3) => {
      var x$1$2 = (x$1$3 | 0);
      return ((x$1$2 < 0) ? x$1$2 : x$2$3.gG(context, text, x$1$2));
    });
    if ((xs === null)) {
      throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
    }
    if ((xs !== null)) {
      var length = xs.a.length;
      var v = position;
      var i$1 = 0;
      while ((i$1 < length)) {
        var x0 = v;
        var x1 = i$1;
        var x1$1 = xs.a[x1];
        v = f(x0, x1$1);
        i$1 = ((1 + i$1) | 0);
      }
      var $x_1 = v;
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
      var length$1 = xs.a.length;
      var v$1 = position;
      var i$2 = 0;
      while ((i$2 < length$1)) {
        var x0$1 = v$1;
        var x1$2 = xs.a[i$2];
        v$1 = f(x0$1, x1$2);
        i$2 = ((1 + i$2) | 0);
      }
      var $x_1 = v$1;
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
      var length$2 = xs.a.length;
      var v$2 = position;
      var i$3 = 0;
      while ((i$3 < length$2)) {
        var x0$2 = v$2;
        var x1$3 = xs.a[i$3];
        v$2 = f(x0$2, x1$3);
        i$3 = ((1 + i$3) | 0);
      }
      var $x_1 = v$2;
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
      var length$3 = ((xs.a.length >>> 1) | 0);
      var v$3 = position;
      var i$4 = 0;
      while ((i$4 < length$3)) {
        var x0$3 = v$3;
        var $x_2 = xs.a;
        var $x_3 = (i$4 << 1);
        var x1$4_$_lo = $x_2[$x_3];
        var x1$4_$_hi = $x_2[(($x_3 + 1) | 0)];
        v$3 = f(x0$3, $j_java$002elang$002e$002dObject.$bL(x1$4_$_lo, x1$4_$_hi));
        i$4 = ((1 + i$4) | 0);
      }
      var $x_1 = v$3;
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
      var length$4 = xs.a.length;
      var v$4 = position;
      var i$5 = 0;
      while ((i$5 < length$4)) {
        var x0$4 = v$4;
        var x1$5 = xs.a[i$5];
        v$4 = f(x0$4, x1$5);
        i$5 = ((1 + i$5) | 0);
      }
      var $x_1 = v$4;
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
      var length$5 = xs.a.length;
      var v$5 = position;
      var i$6 = 0;
      while ((i$6 < length$5)) {
        var x0$5 = v$5;
        var x1$6 = xs.a[i$6];
        v$5 = f(x0$5, $j_java$002elang$002e$002dObject.$bC(x1$6));
        i$6 = ((1 + i$6) | 0);
      }
      var $x_1 = v$5;
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
      var length$6 = xs.a.length;
      var v$6 = position;
      var i$7 = 0;
      while ((i$7 < length$6)) {
        var x0$6 = v$6;
        var x1$7 = xs.a[i$7];
        v$6 = f(x0$6, x1$7);
        i$7 = ((1 + i$7) | 0);
      }
      var $x_1 = v$6;
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
      var length$7 = xs.a.length;
      var v$7 = position;
      var i$8 = 0;
      while ((i$8 < length$7)) {
        var x0$7 = v$7;
        var x1$8 = xs.a[i$8];
        v$7 = f(x0$7, x1$8);
        i$8 = ((1 + i$8) | 0);
      }
      var $x_1 = v$7;
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
      var length$8 = xs.a.length;
      var v$8 = position;
      var i$9 = 0;
      while ((i$9 < length$8)) {
        var x0$8 = v$8;
        var x1$9 = xs.a[i$9];
        v$8 = f(x0$8, x1$9);
        i$9 = ((1 + i$9) | 0);
      }
      var $x_1 = v$8;
    } else {
      if ((!$j_java$002elang$002e$002dObject.$isArrayOf_jl_Void(xs, 1))) {
        throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(xs);
      }
      var length$9 = xs.a.length;
      var v$9 = position;
      var i$10 = 0;
      while ((i$10 < length$9)) {
        var x0$9 = v$9;
        var x1$10 = xs.a[i$10];
        v$9 = f(x0$9, x1$10);
        i$10 = ((1 + i$10) | 0);
      }
      var $x_1 = v$9;
    }
    return ($x_1 | 0);
  }
});
$p.b = (function() {
  var buf = $j_java$002elang$002e$002dObject.$ct_jl_StringBuilder__(new $j_java$002elang$002e$002dObject.$c_jl_StringBuilder());
  if ((this.hI !== null)) {
    var str = (this.jW ? "[" : "(");
    buf.r = (buf.r + str);
    var xs = this.hI;
    var f = ((pp$2) => {
      buf.r = (("" + buf.r) + pp$2);
      return buf;
    });
    var len = xs.a.length;
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var x0 = xs.a[i];
        f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
      while ((i < len)) {
        var x0$1 = xs.a[i];
        f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
      while ((i < len)) {
        var x0$2 = xs.a[i];
        f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
      while ((i < len)) {
        var $x_1 = xs.a;
        var $x_2 = (i << 1);
        var x0$3_$_lo = $x_1[$x_2];
        var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
        f($j_java$002elang$002e$002dObject.$bL(x0$3_$_lo, x0$3_$_hi));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
      while ((i < len)) {
        var x0$4 = xs.a[i];
        f(x0$4);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
      while ((i < len)) {
        var x0$5 = xs.a[i];
        f($j_java$002elang$002e$002dObject.$bC(x0$5));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
      while ((i < len)) {
        var x0$6 = xs.a[i];
        f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
      while ((i < len)) {
        var x0$7 = xs.a[i];
        f(x0$7);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
      while ((i < len)) {
        var x0$8 = xs.a[i];
        f(x0$8);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(xs);
    }
    var str$1 = (this.jW ? "]" : ")");
    buf.r = (buf.r + str$1);
  }
  return buf.r;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$CompositePrinterParser", ({
  lw: 1,
  av: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser };
